import classNames from "classnames";
import Link from "next/link";
import { FC } from "react";
import { MdChevronRight } from "react-icons/md";
import { API } from "../../../services/api/types";
import { formatDate, nrOfYears } from "../../../utils/date";
import slugify from "../../../utils/slugify";
import Flag from "../../Flag";
import SectionHeader from "../../SectionHeader";
import Table from "../../Table/Table";
import TableBody from "../../Table/TableBody";

type ProfileTable = {
  manager: API.Manager;
};

const ProfileTable: FC<ProfileTable> = ({ manager }) => {
  const age = manager.born ? ` (${nrOfYears(manager.born)} år)` : "";

  return (
    <>
      <SectionHeader label="Tränarprofil" />
      <Table>
        <TableBody rowHeight="sm">
          {manager.born && (
            <tr>
              <td>Födelsedatum:</td>
              <td className={classNames("font-semibold")}>
                {`${formatDate(manager.born)}${age}`}
              </td>
            </tr>
          )}

          {manager.nationalitiesText && (
            <tr>
              <td>Nationalitet:</td>
              <td className={classNames("font-semibold")}>
                <span className='flex items-center'>
                  <span className='mr-2'>{manager.nationalitiesText}</span>
                  <Flag
                    country={manager.nationalitiesText}
                  />
                </span>
              </td>
            </tr>
          )}

          {manager.contractLength !== "" && (
            <tr>
              <td>Kontrakt:</td>
              <td className={classNames("font-semibold")}>
                {manager.contractLength}
              </td>
            </tr>
          )}

          {manager.roleName && (
            <tr>
              <td>Roll:</td>
              <td className={classNames("font-semibold")}>
                {manager.roleName}
              </td>
            </tr>
          )}

          {manager.playerProfileId && manager.playerProfileId > 0 ? (
            <Link
              href={`/spelare/${slugify(manager.playerProfileName || "")}/${
                manager.playerProfileId
              }`}
            >
              <tr className="cursor-pointer hover:underline">
                <td className={classNames("font-semibold whitespace-nowrap")}>
                  Visa spelarprofil
                </td>
                <td>
                  <MdChevronRight className="ml-auto" size={20} />
                </td>
              </tr>
            </Link>
          ) : null}
        </TableBody>
      </Table>
    </>
  );
};

export default ProfileTable;
